<template>
  <div class="quiz_container">
    <h2><span style="color:rgb(46,157,208);">巧 </span><span style="color:rgb(233,147,19);">手 </span><span style="color:rgb(221,84,26);">智 </span><span style="color:rgb(44,163,56);">心 </span>STEM 课程教研活动</h2>
    <!-- 绑定老师账号区域 -->
    <div class="BindingButtonBox">
      <el-button  id="BindingButton" type="primary" @click="dialogFormVisible = true">绑定老师</el-button>
      <!-- 弹出绑定窗口 -->
      <el-dialog title="绑定老师" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <!-- 第一行开始 -->
          <el-row>
            <el-col :span="10"><div>
              <i class="el-icon-user"></i>
              <el-form-item label="测评账号1">
                <el-select v-model="form.account1" placeholder="请选择绑定账号" @change="removeSelectOption(form.account1)">
                  <!-- <el-option label="qzjy1" value="qzjy1"></el-option> -->
                  <el-option v-for="item in this.qzjyList" :label="item" :value="item" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div></el-col>
             <el-col :span="2"><div>
              <i class="el-icon-right"  style="margin-top: 30%; color:darkcyan;font-weight: 600;"></i>
            </div></el-col>
            <el-col :span="12"><div>
              <i class="el-icon-user-solid"></i>
              <el-form-item label="老师姓名">
                <el-input v-model="form.account1NickName" autocomplete="off" style="width:80%;"></el-input>
              </el-form-item>
            </div></el-col>
          </el-row>
          <!-- 第一行结束 -->
          <!-- 第二行开始 -->
          <el-row>
            <el-col :span="10"><div>
              <i class="el-icon-user"></i>
              <el-form-item label="测评账号2">
                <el-select v-model="form.account2" placeholder="请选择绑定账号"  @change="removeSelectOption(form.account2)" >
                  <!-- <el-option label="qzjy1" value="qzjy1"></el-option> -->
                  <el-option v-for="item in this.qzjyList" :label="item" :value="item" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div></el-col>
             <el-col :span="2"><div>
              <i class="el-icon-right"  style="margin-top: 30%; color:darkcyan;font-weight: 600;"></i>
            </div></el-col>
            <el-col :span="12"><div>
              <i class="el-icon-user-solid"></i>
              <el-form-item label="老师姓名">
                <el-input v-model="form.account2NickName" autocomplete="off" style="width:80%;"></el-input>
              </el-form-item>
            </div></el-col>
          </el-row>
          <!-- 第二行结束 -->
          <!-- 第三行开始 -->
          <el-row>
            <el-col :span="10"><div>
              <i class="el-icon-user"></i>
              <el-form-item label="测评账号2">
                <el-select v-model="form.account3" placeholder="请选择绑定账号"  @change="removeSelectOption(form.account3)" >
                  <!-- <el-option label="qzjy1" value="qzjy1"></el-option> -->
                  <el-option v-for="item in this.qzjyList" :label="item" :value="item" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div></el-col>
             <el-col :span="2"><div>
              <i class="el-icon-right"  style="margin-top: 30%; color:darkcyan;font-weight: 600;"></i>
            </div></el-col>
            <el-col :span="12"><div>
              <i class="el-icon-user-solid"></i>
              <el-form-item label="老师姓名">
                <el-input v-model="form.account3NickName" autocomplete="off" style="width:80%;"></el-input>
              </el-form-item>
            </div></el-col>
          </el-row>
          <!-- 第三行结束 -->
          <!-- 第四行开始 -->
          <el-row>
            <el-col :span="10"><div>
              <i class="el-icon-user"></i>
              <el-form-item label="测评账号2">
                <el-select v-model="form.account4" placeholder="请选择绑定账号"  @change="removeSelectOption(form.account4)" >
                  <!-- <el-option label="qzjy1" value="qzjy1"></el-option> -->
                  <el-option v-for="item in this.qzjyList" :label="item" :value="item" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div></el-col>
             <el-col :span="2"><div>
              <i class="el-icon-right"  style="margin-top: 30%; color:darkcyan;font-weight: 600;"></i>
            </div></el-col>
            <el-col :span="12"><div>
              <i class="el-icon-user-solid"></i>
              <el-form-item label="老师姓名">
                <el-input v-model="form.account4NickName" autocomplete="off" style="width:80%;"></el-input>
              </el-form-item>
            </div></el-col>
          </el-row>
          <!-- 第四行结束 -->
          <!-- 第五行开始 -->
          <el-row>
            <el-col :span="10"><div>
              <i class="el-icon-user"></i>
              <el-form-item label="测评账号2">
                <el-select v-model="form.account5" placeholder="请选择绑定账号"  @change="removeSelectOption(form.account5)" >
                  <!-- <el-option label="qzjy1" value="qzjy1"></el-option> -->
                  <el-option v-for="item in this.qzjyList" :label="item" :value="item" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div></el-col>
             <el-col :span="2"><div>
              <i class="el-icon-right"  style="margin-top: 30%; color:darkcyan;font-weight: 600;"></i>
            </div></el-col>
            <el-col :span="12"><div>
              <i class="el-icon-user-solid"></i>
              <el-form-item label="老师姓名">
                <el-input v-model="form.account5NickName" autocomplete="off" style="width:80%;"></el-input>
              </el-form-item>
            </div></el-col>
          </el-row>
          <!-- 第五行结束 -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="UpdateqzjyNickName">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 巧智教研图标区域 -->
    <div id="qzchart_container" style="width:100%;">
    </div>
    <div v-if=questionShowFlag>
      <el-card>
        <el-table :data="questionList">
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column label="账号" prop="student_name.username"></el-table-column>
          <el-table-column label="用户" prop="student_name.nick_name"></el-table-column>
          <el-table-column label="课程" prop="course_name.course_name"></el-table-column>
          <el-table-column label="班级" prop="chapter_no">
            <template slot-scope="scope">
              <span v-if="scope.row.chapter_no ==='S1'">小班</span>
              <span v-else-if="scope.row.chapter_no ==='S2'">中班</span>
              <span v-else-if="scope.row.chapter_no ==='S3'">大班</span>
              <span v-else>幼儿班</span>
            </template>
          </el-table-column>
          <el-table-column label="分数" prop="gained_scrore"></el-table-column>
          <el-table-column label="用时" prop="quiz_usedtime"></el-table-column>
          <el-table-column label="完成时间" prop="quiz_completedtime"></el-table-column>
        </el-table>
      </el-card>
      <div class="quiz_box">
        <h3>现已有 <span>{{this.total}}</span> 人完成教研课程! 第一名是: <span style="font-size: 20px;">{{this.questionList[0].student_name.nick_name}}</span></h3>
        <div>
          <el-button type="warning" @click="clearQuizData()">清除测评数据</el-button>
        </div>
      </div>
    </div>
    <div v-else>
      <hr>
      <h3>暂无测评数据</h3>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo: {
        query: '',
        token: ''
      },
      dialogFormVisible: false,
      form: {
        account1: '',
        account1NickName: '',
        account2: '',
        account2NickName: '',
        account3: '',
        account3NickName: '',
        account4: '',
        account4NickName: '',
        account5: '',
        account5NickName: ''
      },
      qzjyList: ['qzjy1', 'qzjy2', 'qzjy3', 'qzjy4', 'qzjy5', 'qzjy6', 'qzjy7', 'qzjy8', 'qzjy9', 'qzjy10', 'qzjy11', 'qzjy12', 'qzjy13', 'qzjy14', 'qzjy15', 'qzjy16', 'qzjy17', 'qzjy18', 'qzjy19', 'qzjy20'],
      questionList: [],
      questionShowFlag: false,
      schoolList: [],
      total: 0,
      refreshtimer: null,
      barXdata: ['巧智教研1', '巧智教研2', '巧智教研3', '巧智教研4', '巧智教研5', '巧智教研6'],
      barYdata: [2, 2, 2, 2, 2, 2]
    }
  },
  created() {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getQuestionList()
    this.getSchoolList()
  },
  mounted() {
    this.refreshtimer = setInterval(() => {
      setTimeout(this.getQuestionList, 0)
    }, 1000 * 5) /* 5000 */
    this.drawBar()
  },
  beforeDestroy() {
    clearInterval(this.refreshtimer)
    this.refreshtimer = null
  },
  methods: {
    async getQuestionList() {
      const { data: res } = await this.$http.get('V3/questionbanklist/', { params: this.queryInfo })
      this.questionList = res
      console.log('res', res)
      console.log('questionList:', this.questionList)
      console.log('total1:', this.total)
      console.log('questionShowFlag1:', this.questionShowFlag)
      if (res.length !== this.total) {
        this.$notify({ title: '成功', message: '有新Quiz信息更新!', type: 'success' })
        this.total = res.length
        this.questionShowFlag = true
        console.log('total2:', this.total)
        console.log('questionShowFlag2:', this.questionShowFlag)
        this.refreshBarOption()
      }
    },
    async getSchoolList() {
      const { data: res2 } = await this.$http.get('schools/')
      this.schoolList = res2
      console.log('schoolList', res2)
      if (res2.length === 0) return this.$notify({ title: '失败', message: '获取学校信息失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取学校信息成功!', type: 'success' })
    },
    drawBar() {
      var myChart = this.$echarts.init(document.getElementById('qzchart_container'))
      // var barXdata = ['巧智教研1', '巧智教研2', '巧智教研3', '巧智教研4', '巧智教研5', '巧智教研6']
      // var barYdata = [2, 2, 2, 2, 2, 2]
      var barOption = {
        title: {
          text: '教师实时测评数据展示'
        },
        tooltip: {},
        xAxis: {
          data: this.barXdata
        },
        yAxis: {
          min: 0, // y轴的最小值
          max: 100, // y轴最大值
          interval: 20 // 值之间的间隔
        },
        series: [
          {
            name: '分数',
            type: 'bar',
            label: {
              show: true,
              postion: 'outside'
            },
            itemStyle: {
              normal: {
                // 好，这里就是重头戏了，定义一个list，然后根据所以取得不同的值，这样就实现了
                color: function(params) {
                  // build a color map as your need.
                  var colorList = [
                    '#C1232B', '#B5C334', '#FCCE10', '#E87C25', '#27727B',
                    '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                    '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0',
                    '#FE8463', '#9BCA63', '#FAD860', '#F3A43B', '#60C0DD',
                    '#D7504B', '#C6E579', '#F4E001', '#F0805A', '#26C0C0'
                  ]
                  return colorList[params.dataIndex]
                }
              }
            },
            // 设置柱的宽度，要是数据太少，柱子太宽不美观~
            // barWidth: 30,
            barMaxWidth: 100,
            // data: [5, 20, 36, 10, 10, 20]
            data: this.barYdata
          }
        ]
      }
      // 绘制图表
      myChart.setOption(barOption)
    },
    refreshBarOption() {
      this.barXdata = []
      this.barYdata = []
      for (let i = 0; i < this.questionList.length; i++) {
        this.barYdata.push(this.questionList[i].gained_scrore)
        this.barXdata.push(this.questionList[i].student_name.nick_name)
      }
      this.drawBar()
    },
    removeSelectOption(value) {
      console.log('selected:', value)
      console.log(this.qzjyList)
      console.log((this.qzjyList.length))
      for (let i = 0; i < this.qzjyList.length; i++) {
        if (this.qzjyList[i] === value) {
          console.log('i=', i)
          console.log((this.qzjyList[i]))
          this.qzjyList.splice(i, 1)
          console.log('after:', this.qzjyList)
          console.log((this.qzjyList.length))
        }
      }
    },
    async UpdateqzjyNickName() {
      console.log('form:', this.form)
      const { data: res } = await this.$http.post('V1/updateqzjynickname/', { token: this.queryInfo.token, accountInfoForm: this.form })
      console.log('res', res)
      if (res.code !== 5000) {
        this.$notify({ title: '失败', message: '更新失败!' + ' -' + res.msg, type: 'error' })
        this.$router.push('/updateNameFail')
      } else {
        this.$notify({ title: '成功', message: '更新成功', type: 'success' })
        // 再跳转到home页面
        this.$router.push('/updateNameSuccess')
      }
    },
    async clearQuizData() {
      const { data: res3 } = await this.$http.get('V3/clearquizdata/', { params: this.queryInfo })
      console.log('---res3-----: ', res3)
      // console.log('---res3-code: ', res3.code)
      if (res3 === 3000) {
        this.questionList = []
        this.total = 0
        this.questionShowFlag = false
        console.log('数据清除成功！', this.questionList)
        this.refreshBarOption()
        this.$notify({ title: '成功', message: '数据清除成功！', type: 'success' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.quiz_container{
  #qzchart_container{
    height: 360px;
    width: 800px;
    text-align: center;
  }
  >h2{
  font-weight: 900;
  text-align: center;
  font-size: 30px;
  }
  >div h3{
    padding-left: 20px;
  }
  >div h3 span{
      font-size: 50px;
      color: coral;
      font-weight: 600;
  }
  .BindingButtonBox{
    // float: right;
    // position: fixed;
    // width: 800px;
    margin-right: 20px;
    position: relative;
  }
  #BindingButton{
    float: right;
    margin-right: 20px;
    position: relative;
    z-index: 10;
    // cursor: pointer;
  }
  .quiz_box{
    display: flex;
    justify-content: space-between;
    >div{
      margin-top: 40px;
      margin-right: 30px;
    }
  }
}
</style>
